// Call Centre customers work leads as "bookings", served from /bookings rather than /leads.
// The search type stays "Lead" underneath because that is what the omni search API understands.

export function searchTypeLabel(type: string, isCallCentre: boolean): string {
  return isCallCentre && type === "Lead" ? "Booking" : type;
}

export function searchResultUrl(type: string | undefined, url: string | undefined, isCallCentre: boolean): string | undefined {
  if (!isCallCentre || type !== "Lead" || url == null) return url;
  return url.replace(/^\/leads(?=\/|$)/, "/bookings");
}
